module.exports = __webpack_public_path__ + "img/ic_sales_right.c9368936.png";